<style lang="stylus">
    .pcview
        display flex
        flex-direction column
        height 100%
        .pcview-row
            margin 0 24px
        .menu-row
            display flex
            justify-content space-between
            margin 24px
        .pcview-box
            flex 1
            height calc(100% - 76px)
        .menu-save
            padding-top 16px
            .pcview-save-title
                font-weight 700
                font-size 16px
                line-height 20px
                margin-bottom 32px
                color #000
        &.dark-theme_pcview
            background #222427
            .menu-save
                .pcview-save-title
                    color #fff
        &.dark-theme_dialogpcview
            background #2a2c2e
</style>

<template>
    <div
        class="pcview"
        :class="{
            'dark-theme_pcview': isPCDarkMode == 2,
            'dark-theme_dialogpcview': isPCDarkMode == 2 && isDialog,
        }"
    >
        <div class="pcview-row menu-row" v-if="!pcSaveInput">
            <topbar :disable="loading" :searchMode="searchMode[menuIndex]" @setMenu="setMenu" @searchBack="searchBack" />
            <topTool
                ref="topTool"
                :menuIndex="menuIndex"
                :hiddenImport="isDialog"
                :searchMode="searchMode[menuIndex]"
                @changeSort="changeSort"
                @changeOrder="changeOrder"
                @applyOrderSort="applyOrderSort"
                @changeLayout="changeLayout"
                @toSearch="toSearch"
                @clickNew="clickNew"
                @clickImport="clickImport"
                @clickTrashTool="clickTrashTool"
            />
        </div>

        <div v-else-if="isDialog" style="padding-top: 16px"></div>

        <div class="pcview-row menu-save" v-else>
            <p class="pcview-save-title">{{ $t("personal") }}</p>
        </div>

        <div class="pcview-box">
            <component :is="activeView" :ref="menuList[menuIndex].label" :type="menuList[menuIndex].type" @setLoading="setLoading"></component>
        </div>

        <Storage v-if="storageVersionLimit && !pcSaveInput" ref="storage" />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import topbar from "./topbar.vue";
    import topTool from "./topTool.vue";
    import viewCloud from "./view-cloud.vue";
    import viewStar from "./view-star.vue";
    import viewShare from "./view-share.vue";
    import viewCollect from "./view-collect.vue";
    import viewPublish from "./view-publish.vue";
    import viewTrash from "./view-trash.vue";
    import Storage from "./storage.vue";

    @Component({
        components: {
            topbar,
            topTool,
            Storage,
        },
    })
    export default class PCView extends Vue {
        menuList: Array<any> = [
            {
                id: 0,
                label: "files",
                type: "file",
            },
            {
                id: 1,
                label: "star",
                type: "star",
            },
            {
                id: 2,
                label: "shareToMe",
                type: "shareToMe",
            },
            {
                id: 3,
                label: "collect",
                type: "collect",
            },
            {
                id: 4,
                label: "publishFile",
                type: "publishFile",
            },
            {
                id: 5,
                label: "trash",
                type: "trash",
            },
        ];
        menuIndex = 0;
        loading = false;
        setLoading(data) {
            console.log("setLoading", data);
            this.loading = data;
        }
        setMenu(id) {
            this.menuIndex = id;
        }
        get activeView() {
            let obj = {
                0: viewCloud,
                1: viewStar,
                2: viewShare,
                3: viewCollect,
                4: viewPublish,
                5: viewTrash,
            };
            return obj[this.menuIndex];
        }
        get activeRef() {
            return this.$refs[this.menuList[this.menuIndex].label] as any;
        }

        changeSort(data) {
            console.log(this.activeRef);
            this.activeRef.setOrder(data);
        }
        changeOrder() {
            this.activeRef.order();
        }
        applyOrderSort(order, sort) {
            this.activeRef.orderName = sort;
            this.activeRef.rotate = order;
        }
        changeLayout(data) {
            this.activeRef.setLayout(data);
        }
        searchMode = [false, false, false, false, false];
        toSearch(data) {
            if (data == "") {
                this.searchBack();
            } else {
                this.searchMode.splice(this.menuIndex, 1, true);
                this.activeRef.searchValue = data;
                this.activeRef.search();
            }
        }
        searchBack() {
            (this.$refs.topTool as any).cleanSearch();
            this.searchMode.splice(this.menuIndex, 1, false);
            this.activeRef.searchBack();
        }
        clickNew(data) {
            if (data == 0) {
                this.activeRef.toCreateFolder();
            } else {
                this.activeRef.toCreateFile();
                this.refreshStorage();
            }
        }
        clickImport() {
            this.activeRef.showImportModal();
        }
        clickTrashTool(data) {
            if (data == "recover") {
                this.activeRef.recycleAllConfirm();
                this.refreshStorage();
            } else if (data == "clear") {
                this.activeRef.recycleClearConfirm();
            }
        }

        refreshStorage() {
            setTimeout(() => {
                let dom = this.$refs.refreshStorage as any;
                dom && dom.refreshStorage();
            }, 1000);
        }

        get pcSaveInput() {
            return this.$store.state.pcSaveInput;
        }

        get storageVersionLimit() {
            return !this.$isBiggerVersion("13.0.2");
        }
        created() {}
        isDialog = false;
        mounted() {
            let urlParmas = new URLSearchParams(location.search.substr(1));
            this.isDialog = !!urlParmas.get("dialog");
        }
    }
</script>
<i18n>
{
    "zh": {
        "personal": "个人云"
    },
    "en": {
        "personal": "Personal"
    },
    "fr": {
        "personal": "Cloud personnel"
    },
    "de": {
        "personal": "Persönliche Cloud"
    },
    "jp": {
        "personal": "個人雲"
    },
    "es": {
        "personal": "Nube personal"
    },
    "pt": {
        "personal": "Nuvem pessoal"
    },
    "it": {
        "personal": "Cloud personale"
    },
    "tw": {
        "personal": "個人云"
    },
    "kr": {
        "personal": "개인 클라우드"
    }
}
</i18n>
